import {
    EventButtonClick,
    EventClientError,
    EventDialogView,
    EventProperties,
    EventServerError,
    EventStepView,
    EventWebPageLoadMetric,
    PropBaseEventProps,
    PropBaseEventPropsV2,
} from '@calm/evexia-analytics';
import isSSR from '@calm/web-common/dist/isSSR';
import { redactActivationTokens } from '@rhg/utils/partner-activation';
import { getOrCreateTabId } from '@rhg/utils/tab-id';
import { BaseProperties } from '../base-context-provider';

export interface EventEnvironmentProps {
    ScreenWidth: number;
    ScreenHeight: number;
    CurrentUrlPath: string;
    CurrentUrlDomain: string;
    TabId: string;
    LoggedHourLocal: number;
}

type AnalyticsEventProps =
    | PropBaseEventProps
    | PropBaseEventPropsV2
    | EventProperties
    | EventButtonClick
    | EventDialogView
    | EventStepView
    | EventServerError
    | EventClientError
    | EventWebPageLoadMetric
    | BaseProperties;

export default function mapBaseEventProps<
    T extends Partial<AnalyticsEventProps>
>(properties?: T): T & EventEnvironmentProps {
    return {
        ...properties,
        ScreenWidth: isSSR() ? 0 : window.innerWidth,
        ScreenHeight: isSSR() ? 0 : window.innerHeight,
        CurrentUrlPath: isSSR()
            ? ''
            : redactActivationTokens(window.location.pathname),
        CurrentUrlDomain: isSSR() ? '' : window.location.origin,
        TabId: getOrCreateTabId(),
        // Emit-time hour, after the spread so a stale caller value (e.g. a
        // memoized player bundle built before an hour boundary) never wins.
        LoggedHourLocal: isSSR() ? 0 : new Date().getHours(),
    } as T & EventEnvironmentProps;
}
